import gsap from 'gsap';
import { Component, OnInit, NgZone, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from "ngx-spinner";
import { first } from "rxjs/operators";
import { Observable } from 'rxjs';

import * as userActions from '../../../store/user/user.actions';

import { AuthService } from "src/app/core-services/auth.service";
import { LoginVM } from "src/app/models/Registration";
import { UserRole } from "src/app/Enum/Enum";
import eventEmitter from "src/app/core-services/eventEmitter";
import UserState from 'src/app/store/user/user.types';
import { Store, select } from '@ngrx/store';
import { selectIsLoggedIn } from 'src/app/store/user/user.reducer';
import { AppState } from 'src/app/app.module';


@Component({
  selector: "login-modal-component",
  templateUrl: "./login-modal.component.html",
  styleUrls: ["./login-modal.component.scss"]
})
export class LoginModalComponent implements OnInit {
    error: any;
    returnUrl: string;
    // loading = false;
    submitted = false;
    loginForm: FormGroup;
    Formdata: any = {};
    deviceInfo = null;
    registerUrl: string;
    emailPattern = /^([\w-\.]+\u0040([\w-]+\.)+[\w-]{2,4})?$/;
    private ipRegex = new RegExp(/([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/);
    tl = gsap.timeline({ paused: true });

    isLoggedIn: boolean;

    constructor(
          private fb: FormBuilder
        , private router: Router
        , private zone: NgZone
        , private authenticationService: AuthService
        , private toastr: ToastrService
        , private cookieService: CookieService
        , private spinner: NgxSpinnerService
        , private http: HttpClient
        , private deviceService: DeviceDetectorService
        , private store: Store<AppState>
        ) {
        // Store stuff
        // redirect to home if already logged in
        this.registerUrl =  window.location.origin + '/signup';
        var currentUser = localStorage.getItem('currentUser');
        // disabled for now since it is a modal and visible verywhere
        if (currentUser != null && currentUser != undefined) {
            // this.router.navigate(['/']);
        }
    }

    ngOnInit() {
        this.loginForm = this.fb.group({
            userName: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$')]],
            remember: [false]
        });

        if (this.cookieService.get('remember')) {
            this.loginForm.controls.userName.setValue(this.cookieService.get('userName'));
            this.loginForm.controls.password.setValue(this.cookieService.get('password'));
            this.loginForm.controls.remember.setValue(this.cookieService.get('remember'));
        }

        // Listen for modal open event
        eventEmitter.on('openLoginModal', (returnUrl) => {
          this.returnUrl = returnUrl;
          this.OpenModal();
        });

        this.tl.to(".login-modal", { opacity: 1, duration: 0.2, pointerEvents: 'all' }, 0);
        this.tl.to(".login-right", { opacity: 1, y: 0, duration: 0.33, ease: 'circ.out' }, 0);
        this.tl.to(".close-icon", { opacity: 1, duration: 0.11, ease: 'circ.out' }, 0.23);
    }

    public OpenModal () {
      const loginModalElement: any = document.querySelector('.login-modal');
      loginModalElement.style.display = 'block';

      this.tl.play();

    }

    public DismissModal (event) {
      if (event) event.stopPropagation();

      setTimeout(() => {
        const loginModalElement: any = document.querySelector('.login-modal');
        loginModalElement.style.display = 'none';
      }, 330)

      this.tl.reverse();
    }

    public cardClick (event) {
      console.log(event);
      event.stopPropagation();
    }


    public hasError = (controlName: string, errorName: string) => {
        return this.loginForm.controls[controlName].hasError(errorName);
    }

    Register(event) {
      this.router.navigate(['/signup']);
      this.DismissModal(event);
    }

    Login() {
        this.submitted = true;
        if (this.loginForm.invalid) {
            if (this.loginForm.controls.password.value != null && this.loginForm.controls.password.value != '') {
                this.toastr.warning('Passwords must contain at least eight characters.', 'Oops !');
            }
            return;
        }
        this.cookieService.deleteAll();
        // store values in cookies
        if (this.loginForm.controls.remember.value == true || this.loginForm.controls.remember.value == 'true') {
            this.cookieService.set('userName', this.loginForm.controls.userName.value);
            this.cookieService.set('password', this.loginForm.controls.password.value);
            this.cookieService.set('remember', this.loginForm.controls.remember.value);
        }
        let model: LoginVM;
        model = this.loginForm.value;
        // this.loading = true;
        this.spinner.show();
        this.authenticationService.login(model).pipe(first()).subscribe((response: any) => {
            if (response != null && response != null && response.isSuccess == true) {
                this.spinner.hide();
                this.store.dispatch(userActions.login());
                if (response.usersDetailsVM != null && response.usersDetailsVM.userRole != null && response.usersDetailsVM.userRole != '') {
                  if (this.returnUrl) {
                    this.router.navigate([this.returnUrl]);
                    this.DismissModal(null);
                    return;
                  }

                  if (response.usersDetailsVM.userRole == UserRole.SuperAdmin) {
                       this.router.navigate(['/searchresultsplash']);
                    }
                    else {
                        if (response.usersDetailsVM.planId != null && response.usersDetailsVM.planId > 0) {
                            this.router.navigate(['/searchresultsplash']);
                        }
                        else {
                            this.router.navigate(['/planselection']);
                        }
                    }
                    this.DismissModal(null);
                }
            }
            else {
                // this.loginForm.reset();
                this.toastr.warning(response.message);
                this.spinner.hide();
                // this.toastr.warning('Invalid Username or Password', 'Oops !');
            }
        },
            error => {
                this.spinner.hide();
                this.error = error;
                // this.loading = false;
            });
    }
}
